import { gql } from '@apollo/client';

export const GET_FOLLOWING = gql`
  query checkFollowing($userId: String!, $targetUser: String!) {
    checkFollowing(userId: $userId, targetUser: $targetUser) {
      success
    }
  }
`;
